import React, { useState, useMemo } from 'react';
import { Modal } from 'antd';
const pdf = require("../assets/ycqzssc.pdf");

function PdfView(props) {
    // 模态框关闭
    const [isModalOpen, setIsModalOpen] = useState(false);
    // 告诉调用对象关闭
    const isOpenToP = (bool) => {
        props.onOpen(bool);
    };

    useMemo(() => {
        if (props.isClose) {
            // pdf手机端下载预览或pc直接预览
            if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
                window.open(props.pdf ? props.pdf : pdf, '_target')
            } else {
                setIsModalOpen(props.isClose);
            }
        } else {
            setIsModalOpen(props.isClose);
        }
    }, [props.isClose]);

    return (
        <Modal
            title={props.title ? props.title : '育才生态区招商手册'}
            centered
            footer={null}
            open={isModalOpen}
            width={1366}
            onCancel={() => {
                setIsModalOpen(false)
                isOpenToP(false)
            }}
        >
            <object
                data={props.pdf ? props.pdf : pdf}
                type="application/pdf"
                width="100%"
                height="600px"
                standby="pdf文档加载中..."
            > </object>
        </Modal>
    );
}

export default PdfView;
